import QuillLink from 'quill/formats/link';
import { MOD_KEY } from '../../constants/os';
import type { Root } from '../types';

const ALLOWED_PROTOCOLS = ['https:', 'http:', 'mailto:', 'tel:', 'webcal:'];
const { HOST } = window.__slab;

const setAttributes = (node: Element & { host?: string }) => {
  if (node.host === window.location.host) {
    node.removeAttribute('target');
  } else {
    node.setAttribute('target', '_blank');
    if (node.host !== HOST) {
      node.setAttribute('rel', 'nofollow noopener noreferrer ugc');
    }
  }
};

class Link extends QuillLink {
  static className = 'ql-link';
  static create(value: string) {
    const node = super.create(value);
    setAttributes(node);
    return node;
  }

  static sanitize(url: string) {
    const anchor = document.createElement('a');
    anchor.href = url;
    if (ALLOWED_PROTOCOLS.includes(anchor.protocol)) {
      if (!url.startsWith(anchor.protocol) && !url.startsWith('#')) {
        return `https://${url}`;
      }
      return url;
    }
    return 'about:blank';
  }

  constructor(scroll: Root, domNode: Element) {
    super(scroll, domNode);

    domNode.addEventListener('click', (event) => {
      // @ts-expect-error
      if (event[MOD_KEY] && scroll.isEnabled()) {
        const href = this.statics.formats(this.domNode);
        if (href) {
          window.open(href, '_blank', 'noopener');
          event.preventDefault();
        }
      }
    });
  }

  format(name: string, value: string) {
    super.format(name, value);
    if (name === Link.blotName && value) {
      setAttributes(this.domNode);
    }
  }
}

export default Link;
